// A single destination policy for the participant section header.
export function sectionBackDestination(s: {
  task: string | null;
  passportUploadResult?: unknown;
  showPassportAvailability?: boolean;
  passportAvailabilityStep: number;
  showingReview?: boolean;
  editingReviewGroup?: boolean;
  passportStep: number;
  profileAssistantStep: number;
  hasProfessionalProfile?: boolean;
  personalStep: number;
  workStep: number;
  professionalProfileStep: number;
  immigrationHistoryStep: number;
}): string {
  if (s.passportUploadResult) return "passport-center";
  if (s.task === "passport") {
    if (s.showPassportAvailability) return s.passportAvailabilityStep > 0 ? "passport-status" : "passport-center";
    if (s.showingReview) return "passport-center";
    if (s.editingReviewGroup) return "review";
    return s.passportStep > 0 ? "previous" : "home";
  }
  if (s.showingReview) return "home";
  if (s.editingReviewGroup) return "review";
  if (s.task === "other_travel_documents") return "parent";
  if (s.task === "profile_assistant") return s.profileAssistantStep === 5 || (s.hasProfessionalProfile && s.profileAssistantStep === 4) ? "home" : "previous";
  const stepMap: Record<string, number> = {
    contact_details: s.personalStep,
    engagement: s.workStep,
    professional_profile: s.professionalProfileStep,
    immigration_history: s.immigrationHistoryStep,
  };
  const step = s.task ? stepMap[s.task] ?? 0 : 0;
  return step > 0 ? "previous" : "home";
}
